import { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';

interface LoadingProps {
  height?: string;
}

const Loading = ({ height = '100vh' }: LoadingProps): ReactElement => {
  const [t] = useTranslation();
  return (
    <Box
      sx={{
        flex: 1,
        height: height,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <p>{t('ALT_TEXT_LOADING')}</p>
    </Box>
  );
};

export default Loading;
